(function () {
  'use strict';

  var ACRONYMS = ['BLC', 'BKLYN', 'NYC', 'LAX'];

  function titleCase(str) {
    return str.replace(/\S+/g, function (word) {
      if (ACRONYMS.indexOf(word.toUpperCase()) >= 0) return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  }

  function fixTitles(root) {
    var scope = root || document;
    scope.querySelectorAll('.blc-collection .card__heading a').forEach(function (a) {
      var text = a.textContent.trim();
      if (text === text.toUpperCase() && text.length > 1) {
        a.textContent = titleCase(text);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fixTitles(); });
  } else {
    fixTitles();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1) {
          if (node.querySelector && node.querySelector('.card__heading a')) {
            fixTitles(node);
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.qa-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    var container = swatch.closest('.qa-swatches');
    container.querySelectorAll('.qa-swatch').forEach(function (s) {
      s.classList.remove('qa-swatch--active');
    });
    swatch.classList.add('qa-swatch--active');

    var colorName = container.querySelector('.blc-color-name');
    if (colorName) {
      colorName.textContent = swatch.getAttribute('title') || '';
    }

    var card = swatch.closest('.card-wrapper') || swatch.closest('.grid__item') || swatch.closest('.pcard');

    var variantImage = swatch.dataset.variantImage;
    if (variantImage && card) {
      var imgs = card.querySelectorAll('.card__media .media img');
      if (!imgs.length) imgs = card.querySelectorAll('.pcard-photo');
      imgs.forEach(function (img) {
        img.src = variantImage;
        img.srcset = variantImage + ' 720w';
      });
    }

    var variantId = swatch.dataset.variantId;
    if (variantId && card) {
      var hiddenInput = card.querySelector('input.product-variant-id');
      if (hiddenInput) {
        hiddenInput.value = variantId;
        hiddenInput.disabled = swatch.dataset.available === 'false';
      }
    }
  });
})();
